import { Component } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import { SignPhoneNumberAdjustment } from 'src/app/model/sign/phone/sign-phone-number-adjustment';
import { SignPhoneNumberAdjustmentOverview } from 'src/app/model/sign/phone/sign-phone-number-adjustment-overview';
import { SignPhoneNumberAdjustmentControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-phone-number-adjustment-controller-request.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { AssociationOption } from '../helper/interfaces/association-option';
import { IPBoardAssociationPickerComponent } from '../ip-board-association-picker.component';
import IPBoardPart from '../../../../../../model/product/ip-board/ip-board-part';

@Component({
  selector: 'ip-board-phone-number-picker',
  templateUrl: '../ip-board-association-picker.component.html',
  styleUrls: ['../ip-board-association-picker.component.scss']
})
export class IPBoardPhoneNumberPickerComponent extends IPBoardAssociationPickerComponent<
  SignPhoneNumberAdjustmentOverview
> {
  constructor(
    protected signPhoneNumberAdjustmentControllerRequestService: SignPhoneNumberAdjustmentControllerRequestService,
    protected projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super(
      signPhoneNumberAdjustmentControllerRequestService,
      projectDisplayObservableService,
      'Telefoonnummer',
      'Gewenste telnr',
      'ander telnr',
      true,
      true,
      true,
      true,
      'previousPhoneNumberContent',
      'previousOtherSidePhoneNumberContent'
    );
  }

  protected initializeAssociationOption(
    option: SignPhoneNumberAdjustmentOverview
  ): AssociationOption<SignPhoneNumberAdjustmentOverview> {
    return {
      label: option.phoneNumber,
      representsDefaultOption: false,
      value: option
    };
  }

  protected initializeDefaultOption(
    ipBoardPart: IPBoardPart
  ): AssociationOption<SignPhoneNumberAdjustmentOverview> {
    return ipBoardPart.sign == null
      ? null
      : {
          label: ipBoardPart.sign.phoneNumber,
          representsDefaultOption: true,
          value: null
        };
  }

  protected initializeOtherValue(): string {
    return this.ipBoardPart.otherPhoneNumber;
  }

  protected initializeOtherSideOtherValue(): string {
    return this.ipBoardPart.otherSideOtherPhoneNumber;
  }

  protected getCurrentSelectedOption(
    ipBoardPart: IPBoardPart
  ): SignPhoneNumberAdjustmentOverview {
    return ipBoardPart.phoneNumberAdjustment;
  }

  protected getCurrentSelectedOtherSideOption(): SignPhoneNumberAdjustmentOverview {
    return this.ipBoardPart.otherPhoneNumberAdjustment;
  }

  protected getOtherOptionLabel(): string {
    return 'Ander telefoonnummer';
  }

  protected wasDefaultOptionSelected(ipBoardPart: IPBoardPart): boolean {
    return (
      ipBoardPart.sign != null &&
      ipBoardPart.phoneNumberAdjustment == null &&
      StringHelper.isEmpty(ipBoardPart.otherPhoneNumber)
    );
  }

  protected wasOtherSideDefaultOptionSelected(): boolean {
    return (
      this.ipBoardPart.sign != null &&
      this.ipBoardPart.otherPhoneNumberAdjustment == null &&
      StringHelper.isEmpty(this.ipBoardPart.otherSideOtherPhoneNumber)
    );
  }

  protected wasOtherOptionSelected(): boolean {
    return (
      this.ipBoardPart.sign == null ||
      (this.ipBoardPart.phoneNumberAdjustment == null &&
        !StringHelper.isEmpty(this.ipBoardPart.otherPhoneNumber))
    );
  }

  protected otherOptionHasValue(): boolean {
    return (
      this.ipBoardPart.phoneNumberAdjustment == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherPhoneNumber)
    );
  }

  protected getOtherOptionValue(): string {
    return this.ipBoardPart.otherPhoneNumber;
  }

  protected wasOtherSideOtherOptionSelected(): boolean {
    return (
      this.ipBoardPart.sign == null ||
      (this.ipBoardPart.otherPhoneNumberAdjustment == null &&
        !StringHelper.isEmpty(this.ipBoardPart.otherSideOtherPhoneNumber))
    );
  }

  protected otherSideOtherOptionHasValue(): boolean {
    return (
      this.ipBoardPart.otherPhoneNumberAdjustment == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherSideOtherPhoneNumber)
    );
  }

  protected getOtherSideOtherOptionValue(): string {
    return this.ipBoardPart.otherSideOtherPhoneNumber;
  }

  protected evaluateShowOtherSidePicker(): boolean {
    return (
      this.selectedOption !== this.otherSideSelectedOption ||
      ((!StringHelper.isEmpty(this.ipBoardPart.otherPhoneNumber) ||
        !StringHelper.isEmpty(this.ipBoardPart.otherSideOtherPhoneNumber)) &&
        this.ipBoardPart.otherPhoneNumber !==
          this.ipBoardPart.otherSideOtherPhoneNumber)
    );
  }

  protected doSetOptionValue(value: SignPhoneNumberAdjustmentOverview): void {
    this.ipBoardPart.phoneNumberAdjustment = <SignPhoneNumberAdjustment>value;
  }

  protected doSetOtherValue(): void {
    this.ipBoardPart.otherPhoneNumber = this.otherValue;
  }

  public doSetOtherOptionValue(value: SignPhoneNumberAdjustmentOverview): void {
    this.ipBoardPart.otherPhoneNumberAdjustment = <SignPhoneNumberAdjustment>(
      value
    );
  }

  protected doSetOtherSideOtherValue(): void {
    this.ipBoardPart.otherSideOtherPhoneNumber = this.otherSideOtherValue;
  }

  protected resetOtherSide(): void {
    this.ipBoardPart.otherPhoneNumberAdjustment = this.ipBoardPart.phoneNumberAdjustment;
    this.ipBoardPart.otherSideOtherPhoneNumber = this.ipBoardPart.otherPhoneNumber;
  }

  protected getDefaultTextFromSign(): string {
    return this.ipBoardPart.sign.phoneNumber;
  }

  protected getTextFromOption(
    option: SignPhoneNumberAdjustmentOverview
  ): string {
    return option.phoneNumber;
  }

  protected alwaysRememberPreviousValues(): boolean {
    return false;
  }
}
